export function assertNever(value: never, context: string): never {
    throw new Error(`Unhandled ${context} value: ${String(value)}`);
}
